module.exports = __webpack_public_path__ + "static/media/model-01.26d0e864.jpg";